import { Injectable } from "@angular/core";
import Handsontable from "handsontable";
import { format } from 'date-fns';
import { HandsontableFieldTypeContrants } from "../constants/handsontable-field-types";

@Injectable({
  providedIn: "root",
})
export class RenderControllerService {
  constructor(
  ) { }

  renderMoneyFormat(field: any) {
    return (instance, td, row, col, prop, value, cellProperties) => {
      if (value !== null && value !== undefined) {
        const number = this.moneyFormat(value);
        td.innerHTML = number != null ? number : '';
        td.className = `htRight htMiddle`;
      } else if (field.note) {
        td.innerHTML = field.note;
        td.className = `htPlaceholder`;
      } else {
        td.innerHTML = "";
      }

      if (cellProperties.readOnly) {
        td.className += ` htDimmed`;
      }
      if (cellProperties.valid === false) {
        td.className += ` htInvalid`;
      }
      return td;
    };
  }

  renderNumber(field: any) {
    return (instance, td, row, col, prop, value, cellProperties) => {
      if (value !== null && value !== undefined) {
        const number = this.moneyFormat(value);
        td.innerHTML = number != null ? number : '';
        td.className = `htRight htMiddle`;
      } else if (field.note) {
        td.innerHTML = field.note;
        td.className = `htPlaceholder`;
      } else {
        td.innerHTML = "";
      }

      if (cellProperties.readOnly) {
        td.className += ` htDimmed`;
      }
      if (cellProperties.valid === false) {
        td.className += ` htInvalid`;
      }
      return td;
    };
  }

  renderPercent(field: any) {
    return (instance, td, row, col, prop, value, cellProperties) => {
      if (value && isNaN(Number(value))) {
        td.innerHTML = value;
        td.className = `htRight htMiddle`;
      } else if (value != null && value !== '' && value !== undefined) {
        const valueNew = +(Math.round(Number(value + 'e+2')) + 'e-2');
        const language = localStorage.getItem('__language');
        if (language === 'vi') {
          value = valueNew.toString().replace(/\./g, ',');
        }
        td.innerHTML = value + '%';
        td.className = `htRight htMiddle`;
      } else if (field.note) {
        td.innerHTML = field.note;
        td.className = `htPlaceholder`;
      } else {
        td.innerHTML = "";
      }

      if (cellProperties.readOnly) {
        td.className += ` htDimmed`;
      }
      if (cellProperties.valid === false) {
        td.className += ` htInvalid`;
      }
      return td;
    };
  }

  moneyFormat(value: string) {
    if (value !== undefined) {
      if (isNaN(Number(value))) {
        return value;
      }
      const arr = value.toString().split('.');
      if (arr[1] && arr[1].length > 2) {
        arr[1] = arr[1].substring(0, 2);
        value = arr.join('.');
      }
      const valueNew = value;
      const language = localStorage.getItem('__language');
      let thousand_separator = language === 'en' ? "," : '.';
      let decimal_separator = language === 'en' ? "." : ',';
      let valueString = '';
      if (language === 'vi') {
        valueString = valueNew.toString().replace(/\./g, ',');
      } else {
        valueString = valueNew.toString().replace(/\,/g, '.');
      }

      let regex = new RegExp("[^" + decimal_separator + "\\d]", "g");
      let number_string = valueString.toString().replace(regex, "").toString();
      let split = number_string.split(decimal_separator);
      let rest = split[0].length % 3;
      let result = split[0].substr(0, rest);
      let thousands = split[0].substr(rest).match(/\d{3}/g);

      if (thousands) {
        let separator = rest ? thousand_separator : "";
        result += separator + thousands.join(thousand_separator);
      }
      result =
        split[1] != undefined ? result + decimal_separator + split[1] : result;
      return Number(value) >= 0 ? result : '-' + result;
    } else {
      return "";
    }
  }

  renderNameGroup(mockTableSettings: any, hansontableControllerService: any) {
    return (hotInstance, td, row, col, prop, value, cellProperties) => {
      if (!mockTableSettings.rows[row]) {
        return td;
      }
      if (!mockTableSettings.rows[row].children || !mockTableSettings.rows[row].duplicate) {
        const rowData = mockTableSettings.rows[row];
        td.innerHTML = value;
        if (rowData.cells && rowData.cells.name && rowData.cells.name.className) {
          td.className = td.className ? td.className + ' ' + rowData.cells.name.className : rowData.cells.name.className;
        }
        return td;
      }
      const buttonAdd: Node = this
        .createDomByStringHtml(`<button class="btn primary"><span class="material-icons">
      add
                </span></button>`);
      const buttonDelete: Node = this.createDomByStringHtml(`
                <button class="btn" class="ml-2"> <i
                class="fa fa-trash"
                style="font-size: 20px"
                aria-hidden="true"
                matTooltip="{{
                  'document_template.tooltip_delete' | translate
                }}"
              ></i></button>
              </div>`);
      const divWrap: Node = this.createDomByStringHtml(
        `<div class="form-check form-check-editor d-flex justify-content-center"></div>`
      );
      let checkGroupDuplicated = false;
      const childCellValue =
        mockTableSettings.rows[row].children &&
          mockTableSettings.rows[row].children[0] &&
          mockTableSettings.rows[row].children[0].cells &&
          mockTableSettings.rows[row].children[0].cells.value
          ? mockTableSettings.rows[row].children[0].cells.value
          : null;
      const codeList = childCellValue ? childCellValue.code.split('_') : null;
      const matched = value && typeof value === 'string' ? value.match(/\(([0-9]{1,})\)/g) : [];
      if (
        matched && matched.length === 1
      ) {
        checkGroupDuplicated = true;
      }
      buttonAdd.addEventListener('click', event => {
        event.preventDefault();
        hotInstance.batch(() => {
          this.duplicateGroup(
            row,
            col,
            mockTableSettings,
            matched && codeList && codeList.length ? codeList[codeList.length - 1] : null,
          );
          const indexRowStart =
            row + mockTableSettings.rows[row].children.length + 1;
          const listRows = mockTableSettings.rows.slice(
            indexRowStart,
            indexRowStart + mockTableSettings.rows[row].children.length + 1
          );
          const dataAdd = hansontableControllerService.mapDataToCell(
            mockTableSettings,
            listRows,
            indexRowStart
          );

          hotInstance.alter(
            'insert_row',
            indexRowStart,
            mockTableSettings.rows[row].children.length + 1
          );
          const data = [];
          const dataAll = {};
          const conditions = [];
          console.log(dataAdd, mockTableSettings);

          for (const [indexAdd, rowAd] of dataAdd.entries()) {
            const index = indexRowStart + indexAdd;
            const rowData = mockTableSettings.rows[index];
            if (index >= indexRowStart && index <= indexRowStart + listRows.length) {
              if (rowAd.value) {
                dataAll[rowData.cells.value.code] = {
                  value: rowAd.value
                };
              }
              data.push([index, 0, rowAd.orderNo])
              data.push([index, 1, rowAd.name]);
              if (rowData.cells && rowData.cells.signingCustomer) {
                data.push([index, 4, rowData.cells.signingCustomer.value || '']);
              }
              if (rowAd.value) {
                data.push([index, 2, rowAd.value]);
              } else if (
                rowData.cells &&
                rowData.cells.value &&
                rowData.cells.value.defaultValue
              ) {
                data.push([index, 2, rowData.cells.value.defaultValue]);
              } else if (
                rowData.cells &&
                rowData.cells.value &&
                rowData.cells.value.type &&
                (rowData.cells.value.type.code === HandsontableFieldTypeContrants.number ||
                  rowData.cells.value.type.code === HandsontableFieldTypeContrants.numberPercent ||
                  rowData.cells.value.type.code === HandsontableFieldTypeContrants.moneyFormat) &&
                rowData.cells.value.dataType && rowData.cells.value.dataType.code !== 'formula') {
                data.push([index, 2, '0']);
              }

              if (rowData.hide) {
                conditions.push({
                  index
                });
              }
            } else {
              if (rowData.children) {
                data.push([index, 1, rowAd.name]);
              } else if (rowData.cells && rowData.cells.value && rowData.cells.value.formula) {
                data.push([index, 2, rowAd.value]);
              }
            }
          }
          if (conditions.length) {
            const hiddenRows = hotInstance.getPlugin('hiddenRows');
            conditions.forEach(item => {
              hiddenRows.hideRow(item.index);
            });
          }
          const mergeCellPlugin = hotInstance.getPlugin('mergeCells');
          mergeCellPlugin.merge(indexRowStart, 1, indexRowStart, 2);
          hotInstance.setDataAtCell(data, 'change');
          hotInstance.render();
          // hotInstance.getPlugin('formulas').recalculateFull();
        })
      });
      buttonDelete.addEventListener('click', event => {
        event.preventDefault();
        hotInstance.batch(() => {
          hotInstance.alter(
            'remove_row',
            row,
            mockTableSettings.rows[row].children.length + 1
          );
          this.deleteGroup(row, col, mockTableSettings);
          const dataNew =
            hansontableControllerService.mapDataToCell(mockTableSettings);
          let checkRowBehindGroup = false;
          for (const [indexNew, iterator] of dataNew.entries()) {
            if (
              indexNew >= row &&
              !checkRowBehindGroup &&
              mockTableSettings.rows[indexNew] &&
              !mockTableSettings.rows[indexNew].cells.child &&
              (!mockTableSettings.rows[indexNew].children ||
                !mockTableSettings.rows[indexNew].duplicate)
            ) {
              const cellMeta = hotInstance.getCellMeta(indexNew, 2);
              delete cellMeta.renderer;
              hotInstance.setCellMetaObject(indexNew, 2, cellMeta);
              // const mergeCellPlugin = hotInstance.getPlugin('mergeCells');
              // mergeCellPlugin.unmerge(indexNew, 1, indexNew, 2);
              checkRowBehindGroup = true;
              if (indexNew == row) {
                hotInstance.setDataAtCell(indexNew, 1, iterator.name, 'insert');
              }
            } else if (indexNew >= row && mockTableSettings.rows[indexNew] && mockTableSettings.rows[indexNew].children && mockTableSettings.rows[indexNew].duplicate) {
              hotInstance.setDataAtCell(indexNew, 1, iterator.name, 'insert');
            } else if (indexNew == row) {
              hotInstance.setDataAtCell(indexNew, 1, iterator.name, 'insert');
            }
          }
          hotInstance.render();
          // hotInstance.getPlugin('formulas').recalculateFull();
        })
      });
      divWrap.appendChild(buttonAdd);
      if (checkGroupDuplicated) {
        divWrap.appendChild(buttonDelete);
      }
      const div: Node = this.createDomByStringHtml(
        `<div class="d-flex justify-content-between"></div>`
      );
      const name: Node = this.createDomByStringHtml(
        `<div class="htDimmed d-flex flex-column justify-content-center">${value}<div>`
      );
      div.appendChild(name);
      div.appendChild(divWrap);
      Handsontable.dom.empty(td);
      td.appendChild(div);
    };
  }

  public duplicateGroup(
    row: any,
    col: any,
    mockTableSettings: any,
    timeDuplicated: string
  ): any {
    // Duplicate case group
    if (
      mockTableSettings.rows &&
      mockTableSettings.rows[row] &&
      mockTableSettings.rows[row].children
    ) {
      const clonedMockTableSettings = JSON.parse(
        JSON.stringify(mockTableSettings)
      );
      const currentRow = clonedMockTableSettings.rows[row];
      currentRow.fieldId = null;
      currentRow.field.fieldId = null;
      const time = format(new Date(),'YYYYMMDDHHmmss');
      for (const child of currentRow.field.children) {
        child.fieldId = null;
        child.fieldConfig = this.changeCodeDuplicate(
          currentRow.childCode,
          child.fieldConfig,
          time,
          timeDuplicated
        );
      }
      const code = [];
      for (let cell of currentRow.children) {
        const fieldConfig = cell.field && cell.field.fieldConfig ? cell.field.fieldConfig : null;
        if (cell.field && cell.field.fieldId) {
          cell.field.fieldId = null;
        }
        cell.cells.value.value = fieldConfig && fieldConfig.defaultValue ? fieldConfig.defaultValue : null;
        cell.cells.value.valueId = null;
        cell.cells.value = this.changeCodeDuplicate(
          currentRow.childCode,
          cell.cells.value,
          time,
          timeDuplicated
        );
        cell.field.fieldConfig = this.changeCodeDuplicate(
          currentRow.childCode,
          cell.field.fieldConfig,
          time,
          timeDuplicated
        );
        cell = this.changeCodeDuplicate(
          currentRow.childCode,
          cell,
          time,
          timeDuplicated
        );
        if (cell.cells.value.filterData) {
          delete cell.cells.value.filterData;
        }
        if (cell.cells.value && cell.cells.value.data) {
          if (cell.cells.value.relatedFieldDataCode) {
            cell.cells.value.filterData = [];
          } else {
            cell.cells.value.filterData = cell.cells.value.data;
          }
        }
        code.push(cell.cells.value.code);
      }
      console.log(currentRow);

      currentRow.childCode = code;
      mockTableSettings.rows = [
        ...mockTableSettings.rows.slice(
          0,
          row + 1 + currentRow.children.length
        ),
        currentRow,
        ...currentRow.children,
        ...mockTableSettings.rows.slice(row + 1 + currentRow.children.length)
      ];

      return;
    }
  }

  public deleteGroup(row: any, col: any, mockTableSettings: any): void {
    // Delete group row
    if (
      mockTableSettings.rows &&
      mockTableSettings.rows[row] &&
      mockTableSettings.rows[row].children &&
      mockTableSettings.rows[row].children.length
    ) {
      const currentRow = mockTableSettings.rows[row];
      mockTableSettings.rows.splice(row, 1 + currentRow.children.length);
      return;
    }
    // Delete related row
    if (
      mockTableSettings.rows &&
      mockTableSettings.rows[row] &&
      mockTableSettings.rows[row].relatedRows &&
      mockTableSettings.rows[row].relatedRows.length
    ) {
      const currentRow = mockTableSettings.rows[row];
      mockTableSettings.rows.splice(row, 1 + currentRow.relatedRows.length);
      return;
    }
    mockTableSettings.rows.splice(row, 1);
    return;
  }

  createDomByStringHtml(strHtml: string): Node {
    return new DOMParser().parseFromString(strHtml, 'text/html').body
      .childNodes[0];
  }

  public renderCheckboxController(field: any): any {
    return (hotInstance, td, row, prop, col, value, cellProperties) => {
      // Render dom repend on state
      // let listController = '';
      const divWrap: Node = this.createDomByStringHtml(`<div></div>`);
      if (cellProperties.valid === false) {
        td.className += ' htInvalid';
      }
      let valueId = [];
      if (value && value.substring(0, 1) === '[' && value.substring(value.length - 1) === ']') {
        valueId = JSON.parse(value);
      }
      for (const sourceField of field.data) {
        let isChecked = '';
        const disabled = !field.editable ? 'disabled' : '';
        if (valueId && valueId.includes(sourceField.id)) {
          isChecked = 'checked';
        }
        const checkbox: Node = this.createDomByStringHtml(
          `<input class="form-check-input checkbox-${field.code}" name="${sourceField.value}" type="checkbox" value="${sourceField.id}" ${isChecked} ${disabled}>`
        );
        const label: Node = this.createDomByStringHtml(
          `<label class="form-check-label" for="${sourceField.code}" style="margin-left: 5px;">${sourceField.value}</label>`
        );
        const listController: Node = this.createDomByStringHtml(
          `<div class="form-check"></div>`
        );
        checkbox.addEventListener('change', (event: any) => {
          this.checkboxClickHandler(event, row, col, hotInstance, valueId);
        });
        listController.appendChild(checkbox);
        listController.appendChild(label);
        divWrap.appendChild(listController);
      }
      td.style.whiteSpace = 'normal';
      Handsontable.dom.empty(td);
      td.appendChild(divWrap);
    };
  }

  public checkboxClickHandler(
    event: any,
    col: number,
    row: number,
    hotInstance: any,
    valueId: any
  ): void {
    let cellValueIdHolder = valueId;
    if (event.target.checked) {
      cellValueIdHolder.push(event.target.value);
    } else {
      cellValueIdHolder = cellValueIdHolder.filter(valueId => {
        return valueId !== event.target.value;
      });
    }
    const valueIdString =
      cellValueIdHolder.length > 0 ? JSON.stringify(cellValueIdHolder) : null;
    hotInstance.setDataAtRowProp(col, row, valueIdString);
  }

  public renderRadioController(field: any): any {
    return (hotInstance, td, row, prop, col, value, cellProperties) => {
      // Render dom repend on state
      // let listController = '';
      const divWrap: Node = this.createDomByStringHtml(`<div></div>`);
      if (cellProperties.valid === false) {
        td.className += ' htInvalid';
      }
      for (const sourceField of field.data) {
        let isChecked = '';
        const disabled = !field.editable ? 'disabled' : '';
        if (value === sourceField.id) {
          isChecked = 'checked';
        }
        const radio: Node = this.createDomByStringHtml(
          `<input class="form-check-input radio-${field.code}" id="${field.code}_${sourceField.id}" name="${field.code}" type="radio" value="${sourceField.id}" ${isChecked} ${disabled}>`
        );
        const label: Node = this.createDomByStringHtml(
          `<label class="form-check-label" for="${field.code}_${sourceField.id}" style="margin-left: 5px;">${sourceField.value}</label>`
        );
        const listController: Node = this.createDomByStringHtml(
          `<div class="form-check"></div>`
        );
        radio.addEventListener('change', (event: any) => {
          hotInstance.setDataAtCell(row, 2, event.target.value);
        });
        listController.appendChild(radio);
        listController.appendChild(label);
        divWrap.appendChild(listController);
      }
      td.style.whiteSpace = 'normal';
      Handsontable.dom.empty(td);
      td.appendChild(divWrap);
    };
  }

  private changeCodeDuplicate(
    code: string[],
    object: any,
    stringAdd: string,
    timeDuplicated: string
  ) {
    for (const key of Object.keys(object)) {
      const value =
        object[key] && typeof object[key] === 'string' ? object[key] : '';
      let check = false;
      code.forEach(item => {
        if (value.includes(item)) {
          check = true;
        }
      });
      if (check) {
        if (
          key !== 'formula' &&
          key !== 'showCondition' &&
          key !== 'fixedFieldCode'
        ) {
          if (timeDuplicated) {
            object[key] = object[key].replace(timeDuplicated, stringAdd);
          } else {
            object[key] += `_${stringAdd}`;
          }
        } else if (key === 'fixedFieldCode') {
          const splitFieldCode = value.split('-');
          splitFieldCode.forEach(fieldCode => {
            if (code.includes(fieldCode)) {
              if (timeDuplicated) {
                object[key] = object[key].replace(
                  fieldCode,
                  fieldCode.replace(timeDuplicated, stringAdd)
                );
              } else {
                object[key] = object[key].replace(
                  fieldCode,
                  fieldCode + '_' + stringAdd
                );
              }
            }
          });
        } else {
          const regexCode = /<[A-Z0-9_]*>/g;
          const listCode = value.match(regexCode);
          if (listCode && listCode.length) {
            listCode.forEach(element => {
              if (code.includes(element.substring(1, element.length - 1))) {
                if (timeDuplicated) {
                  const stringNew = element.replace(timeDuplicated, stringAdd);
                  object[key] = object[key].replace(element, stringNew);
                } else {
                  const stringNew = `${element.slice(
                    0,
                    element.length - 1
                  )}_${stringAdd}${element.slice(element.length - 1)}`;
                  object[key] = object[key].replace(element, stringNew);
                }
              }
            });
          }
        }
      }
    }
    return object;
  }
}
